const PERSISTED_CHAT_ERROR_SESSION_KEY_PREFIX = 'vpe-ai-assistant-chat-error';

export const vpePersistedChatErrorSessionKey = (documentId, userId) =>
  `${PERSISTED_CHAT_ERROR_SESSION_KEY_PREFIX}:${documentId}:${userId}`;

export const hasVpePersistedChatError = ({ documentId, userId, dus }) => {
  if (dus?.root?.error?.value === 'aiAssistantChatError') return true;
  try {
    return sessionStorage.getItem(vpePersistedChatErrorSessionKey(documentId, userId)) === '1';
  } catch {
    return false;
  }
};

export const markVpePersistedChatError = (documentId, userId) => {
  try {
    sessionStorage.setItem(vpePersistedChatErrorSessionKey(documentId, userId), '1');
  } catch { /* sessionStorage unavailable */ }
};

export const clearVpePersistedChatError = (documentId, userId) => {
  try {
    sessionStorage.removeItem(vpePersistedChatErrorSessionKey(documentId, userId));
  } catch { /* sessionStorage unavailable */ }
};

export const resetVpePersistedChatErrorSessionStateForTests = () => {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(`${PERSISTED_CHAT_ERROR_SESSION_KEY_PREFIX}:`))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch { /* sessionStorage unavailable */ }
};

const resolveDocumentIdFromDom = () =>
  document.querySelector('[data-case-experience--case-viewer-document-id-value]')
    ?.getAttribute('data-case-experience--case-viewer-document-id-value')
  || document.querySelector('[data-case-experience--ai-assistant-chat-document-id-value]')
    ?.getAttribute('data-case-experience--ai-assistant-chat-document-id-value')
  || null;

const resolveUserIdFromDom = () =>
  document.getElementById('document-container')?.getAttribute('data-case-experience--case-viewer-user-id-value')
  || document.querySelector('[data-case-viewer-user-id-value]')?.getAttribute('data-case-viewer-user-id-value')
  || document.querySelector('[data-case-experience--ai-assistant-chat-user-id-value]')
    ?.getAttribute('data-case-experience--ai-assistant-chat-user-id-value')
  || null;

export const clearVpePersistedChatErrorOnModalClose = (modalRoot) => {
  const variant = modalRoot?.dataset?.vpeFallbackErrorModalVariant;
  if (variant && variant !== 'chat') return;

  const documentId = resolveDocumentIdFromDom();
  const userId = resolveUserIdFromDom();
  if (documentId && userId) clearVpePersistedChatError(documentId, userId);
};
